import { render, staticRenderFns } from "./sidebar-layout.vue?vue&type=template&id=a8ecc470&"
import script from "./sidebar-layout.vue?vue&type=script&lang=ts&"
export * from "./sidebar-layout.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAppBar,VAppBarNavIcon,VContainer,VFooter,VMain})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ecc470')) {
      api.createRecord('a8ecc470', component.options)
    } else {
      api.reload('a8ecc470', component.options)
    }
    module.hot.accept("./sidebar-layout.vue?vue&type=template&id=a8ecc470&", function () {
      api.rerender('a8ecc470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layouts/sidebar-layout.vue"
export default component.exports